//---- Dependencies ----//
import { combineReducers } from 'redux';

//---- Reducers ----//
import user from "./User";
import home from "./Home";
import trip from "./Trip";
import base from "./Base";
import header from "./Header";
import itinerary from "./Itinerary";
import itinerary_type from "./ItineraryType";
import accommodation from "./Accommodation";
import poi from "./Poi";
import cars_search from "./CarsSearch";
import booking from "./Booking";
import summary from "./Summary";
import transfers from "./Transfers";
import pictures from "./Pictures";
import payment from "./Payment";
import locale from "./Locale";
import picture from "../Components/Menu/MaterialTripList/picture/redux/reducer";
import mapSlice from "../Components/Map/redux/reducer";
import cartConstructionSlice from "../Components/CartMaterial/redux/cartConstructionReducer";
import pageDestinationSlice from "../Components/pages/redux/destinationSlice";
import pageCircuitSlice from "../Components/pages/redux/circuitSlice";
import pageBuilderSlice from "../Components/pages/redux/pageBuilderSlice";
import themeSlice from "../Components/Menu/Settings/redux/themeSlice";
import { pageBuilderApi } from "../Components/Menu/Settings/page-builder/api/pageBuilderApi";
import { packagesApi } from "../Components/Menu/Settings/page-builder/api/packagesApi";
import { commonApi } from "../Components/Menu/Settings/page-builder/api/commonApi";

const reducers = {
    /*your app’s top-level reducers */
    user,
    home,
    trip,
    base,
    booking,
    accommodation,
    header,
    itinerary,
    itinerary_type,
    summary,
    poi,
    cars_search,
    transfers,
    pictures,
    payment,
    picture,
    locale,
    [mapSlice.name]: mapSlice.reducer,
    [cartConstructionSlice.name]: cartConstructionSlice.reducer,
    [themeSlice.name]: themeSlice.reducer,
    page: combineReducers({
        [pageDestinationSlice.name]: pageDestinationSlice.reducer,
        [pageCircuitSlice.name]: pageCircuitSlice.reducer,
        [pageBuilderSlice.name]: pageBuilderSlice.reducer,
    }),
    [pageBuilderApi.reducerPath]: pageBuilderApi.reducer,
    [packagesApi.reducerPath]: packagesApi.reducer,
    [commonApi.reducerPath]: commonApi.reducer,
};

export default reducers;
